import { useState } from "react";
import { Modal, Button, Spinner, Badge } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PricingModal = ({ show, onHide, selectedPlan }) => {
  const navigate = useNavigate();

  const USERS_INCLUDED = 100;
  const GST_PERCENT = 18;

  const yearlyPrice = 2999;
  const gstAmount = Math.round((yearlyPrice * GST_PERCENT) / 100);
  const finalTotal = yearlyPrice + gstAmount;

  const [loading, setLoading] = useState(false);

  const loadRazorpay = () =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const handlePayment = () => {
    toast.warning("Please sign in to continue");

    setTimeout(() => {
      navigate("/signin", {
        state: { from: "pricing", plan: selectedPlan },
      });
    }, 1200);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold text-primary">
          {selectedPlan?.name} Plan
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-center mb-4">
          <Badge bg="primary" className="fs-6 px-4 py-2 rounded-pill">
            ₹{yearlyPrice.toLocaleString()} / Year
          </Badge>
        </div>

        <div className="mb-4">
          <div className="mb-2">✔ 1 Year Validity</div>
          <div className="mb-2">✔ {USERS_INCLUDED} Users Included</div>
          <div className="mb-2">
            ✔ ₹{yearlyPrice.toLocaleString()} + GST ({GST_PERCENT}%)
          </div>
        </div>

        <div className="bg-light p-3 rounded d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Final Total</span>
          <span className="fw-bold text-success fs-5">
            ₹{finalTotal.toLocaleString()}
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handlePayment} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Proceed to Pay"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PricingModal;
